export const BALANCE_KEY_SEGMENT = 'balance';
